import Rest from 'utils/rest'
import {API2_FEEDBACK} from 'consts/api2'

export function routeMatches(currentPath, path){
  return currentPath === path || currentPath.startsWith(`${path}/`)
}

export function isCurrentRoute($route, item){
  const paths = item.matched_routes?.length ? item.matched_routes : [item.route]
  if (!paths.some(path => routeMatches($route.path, path))) return false

  return Object.entries(item.query || {}).every(([key, value]) => {
    return $route.query[key] === value
  })
}

export async function sendFeedback(message){
  const rest = new Rest()
  await rest.post(API2_FEEDBACK, {message})
}
